// src/utils/tooltipManager.js

class TooltipManager {
  constructor() {
    this.activeTooltips = new Set();
    this.callbacks = new Map();
  }

  register(tooltipId, hideCallback) {
    this.callbacks.set(tooltipId, hideCallback);
  }

  unregister(tooltipId) {
    this.callbacks.delete(tooltipId);
    this.activeTooltips.delete(tooltipId);
  }

  show(tooltipId) {
    // Hide all other tooltips
    this.activeTooltips.forEach(activeId => {
      if (activeId !== tooltipId) {
        const callback = this.callbacks.get(activeId);
        if (callback) {
          callback();
        }
      }
    });
    
    // Clear and add current tooltip
    this.activeTooltips.clear();
    this.activeTooltips.add(tooltipId);
  }

  hide(tooltipId) {
    this.activeTooltips.delete(tooltipId);
  }

  hideAll() {
    this.activeTooltips.forEach(activeId => {
      const callback = this.callbacks.get(activeId);
      if (callback) {
        callback();
      }
    });
    this.activeTooltips.clear();
  }
}

// Create a global instance
const tooltipManager = new TooltipManager();

export default tooltipManager; 